import {
  StyledLegendMenu,
  StyledLegendMenuItem,
  StyledLegendMenuList,
  StyledLegendSymbol,
  StyledMenuSubHeader
} from './LegendMenu.style';
import { PROBABILITY_COLORS } from '../../chart.utils';
import useCustomDatesLegends from './useCustomDatesLegends';

const LegendMenu = ({ forecast, setDateInView, monthsInView }) => {
  const customDatesLegends = useCustomDatesLegends({ monthsInView });

  return (
    <StyledLegendMenu>
      <StyledLegendMenuList>
        {customDatesLegends.map((legend, idx) => {
          const { date, color, title, isClickable } = legend;
          return (
            <StyledLegendMenuItem
              key={idx}
              {...(isClickable && { onClick: () => setDateInView(date) })}
            >
              <StyledLegendSymbol color={color} /> {title}
            </StyledLegendMenuItem>
          );
        })}
      </StyledLegendMenuList>

      <StyledMenuSubHeader>Probability of completion</StyledMenuSubHeader>
      <StyledLegendMenuList>
        {PROBABILITY_COLORS.map(({ range, color }) => {
          const percentRanges = range.map(num => (num * 100).toFixed(0));
          return (
            <StyledLegendMenuItem key={color}>
              <StyledLegendSymbol fill color={color} />
              {percentRanges[0]} - {percentRanges[1]}%
            </StyledLegendMenuItem>
          );
        })}
      </StyledLegendMenuList>
    </StyledLegendMenu>
  );
};

export default LegendMenu;
